var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/tag",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.9174298,0.649042611 L2.133644,6.96293765 C1.5788827,7.36170996 1.25,8.00314136 1.25,8.68635178 L1.25,21.6275337 C1.25,22.7997764 2.20024459,23.75 3.37246626,23.75 L20.9400343,23.75 C22.1122885,23.75 23.0625006,22.7997879 23.0625006,21.6275337 L23.0625006,8.68635178 C23.0625006,8.00316108 22.7336182,7.36172307 22.1788847,6.96294998 L13.3951016,0.64905689 C12.6549362,0.116983417 11.6576263,0.116983417 10.9174298,0.649042611 Z M12.5195612,1.86701787 L21.3033633,8.18092463 C21.4660408,8.29786621 21.5625006,8.48599721 21.5625006,8.68635178 L21.5625006,21.6275337 C21.5625006,21.9713607 21.2838613,22.2499998 20.9400343,22.2499998 L3.37246626,22.2499998 C3.02866429,22.2499998 2.75,21.9713419 2.75,21.6275337 L2.75,8.68635178 C2.75,8.48598624 2.84645113,8.29787423 3.0091504,8.1809231 L11.7929323,1.86703087 C12.0100128,1.71099166 12.3025137,1.71099166 12.5195612,1.86701787 Z",
  id: "Path",
  fill: "#32373C",
  fillRule: "nonzero"
}))));
export { SvgTag as ReactComponent };
export default __webpack_public_path__ + "images/tag.svg";